import 'react';
import LoadingComponent from './LoadingComponent';
import {forEach} from 'lodash';

class LoadingAndValidateComponent extends LoadingComponent {
	yupValidate = undefined;

	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			params: {},
			errors: {},
		}
		this.validate = this.validate.bind(this);
		window.addEventListener('changeLocalization', () => {
			if (!window._.isEmpty(this.state.errors)) {
				this.validate();
			}
		});
	}

	async validate() {
		try {
			await this.yupValidate.validate(this.state.params, {abortEarly: false});
		} catch (error) {
			let errors = {};
			forEach(error.inner, (err) => {
				errors[err.path] = err.message;
			});
			this.setState({errors});
		}

		return await this.yupValidate.isValid(this.state.params);
	}

	clearErrors = () => {
		this.setState({errors: {}});
	}
}

export default LoadingAndValidateComponent;
